import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllRAIIdsByAlbum = (albumId: string | undefined) : string[] => {
  const raiDb = useSelector((state: RootState) => state.relationAlbumImageDb);
  const ids = Object.keys(raiDb.relationAlbumImages).filter(id => raiDb.relationAlbumImages[id].albumId === albumId);

  return ids;
}

export default useAllRAIIdsByAlbum;
